import React, { useState } from "react";
import { Button, Segment, Select } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import {
  ListPermission,
  PermissionForm,
} from "../../../components/Admin/Permission";
import "./Permission.scss";

export function Permission() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const [selectedSection, setSelectedSection] = useState("");

  const sections = [
    "Gestión de asistencia",
    "Categorías de pago",
    "Ciclos académicos",
    "Grados",
    "Mallas curriculares",
    "Asignaturas",
    "Usuarios",
    "Tipos de usuario",
    "Permisos",
    "Notificaciones",
    "PRUEBA",
  ];

  const selectOptions = [
    { key: "", value: "", text: "Selecciona una sección" },
    ...sections.map((section) => ({
      key: section,
      value: section,
      text: section,
    })),
  ];

  return (
    <>
      <div className="permission-page">
        <Button
          className="permission-page__add"
          primary
          onClick={onOpenCloseModal}
        >
          Nuevo Permiso
        </Button>

        <Select
          className="permission-page__filter-select edunova-select"
          value={selectedSection}
          options={selectOptions}
          clearable
          onChange={(_, data) => setSelectedSection(data.value)}
          placeholder="Selecciona una sección"
        />

        <div className="permission-page__content">
          <Segment>
            <ListPermission
              reload={reload}
              section={selectedSection}
              onReload={onReload}
            />
          </Segment>
        </div>
      </div>
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Crear permiso"
      >
        <PermissionForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}
